import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 690 212",
    fill: "none",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M130 22.5h430c8.56 0 15.5 6.94 15.5 15.5v136c0 8.56-6.94 15.5-15.5 15.5H130c-8.56 0-15.5-6.94-15.5-15.5V38c0-8.56 6.94-15.5 15.5-15.5Z" stroke="#E3DFDB"/> <path fill="#D9D9D9" d="M138 46h212v24H138zm0 40h368v16H138zm0 24h158v16H138zm0 36h74v16h-74z"/> <path d="M220 154c0-6.627 5.373-12 12-12h66c6.627 0 12 5.373 12 12s-5.373 12-12 12h-66c-6.627 0-12-5.373-12-12" fill="#E3E8F0"/> <path fill="#BDBAB7" d="M228 150h74v8h-74z"/>' }
  })
);